import { CEBlockBase } from './ce-block-base'


export class CEBlock extends CEBlockBase {

}